/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { saveAs } from 'file-saver';
import { service } from '@ember/service';

import AnalyticsService from 'cio/services/analytics';
import TemplateModel from 'cio/models/template';
import { ComposerEditableEntityAnalyticsData } from 'cio/utils/composer/composer-editable-entity';

interface ExportToHtmlArgs {
  template: TemplateModel;
  analyticsData?: ComposerEditableEntityAnalyticsData | null;
}

export default class ExportToHtml extends Component<ExportToHtmlArgs> {
  @service analytics!: AnalyticsService;

  @action
  export() {
    this.trackExportHtml();

    let { id, body } = this.args.template;
    let blob = new Blob([body], { type: 'text/html;charset=utf-8;' });
    return saveAs(blob, `template-${id}.html`);
  }

  @action
  trackExportHtml() {
    if (this.args.analyticsData != null) {
      this.analytics.track('message', 'exported_html', {
        ...this.args.analyticsData,
        builderType: 'Drag n Drop',
      });
    }
  }
}
